import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate, useLocation } from "react-router-dom";
import { validateOTP } from "./OTPValidator";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes" });

const BillOTPWrapper = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [otpValidated, setOtpValidated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isAlreadyValidated = ls.get("otpValidatedForBills");
    if (isAlreadyValidated) {
      setOtpValidated(true);
      setLoading(false);
      return;
    }

    const validate = async () => {
      const result = await validateOTP(`Access ${location.pathname}`);
      if (result.status === "success") {
        ls.set("otpValidatedForBills", true);
        setOtpValidated(true);
        setLoading(false);
      } else if (result.status === "cancel") {
        navigate("/dashboard");
      }
    };

    validate();
  }, [location.pathname, navigate]);

  return (
    <Box sx={{ position: "relative", padding: 3 }}>
      {/* Blur the content if still validating */}
      <Box
        sx={{
          filter: loading ? "blur(5px)" : "none",
          pointerEvents: loading ? "none" : "auto",
          opacity: loading ? 0.6 : 1,
          transition: "all 0.3s ease-in-out",
        }}
      >
        {children}
      </Box>

      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(3px)",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6">Validating OTP...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default BillOTPWrapper;
